import { useState } from 'react';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { useLazyGetTedReceiptQuery, useLazyGetTedReceiptV2Query } from '../../services/receiptApi';
export function useGetTedReceipt() {
    const { isFeatureFlagWhiteListed } = useFeatureFlag();
    const isBaasV2Enabled = isFeatureFlagWhiteListed(FeatureFlagUseCase.CORE_BANKING_ENABLE_BAAS_V2);
    const [triggerV1] = useLazyGetTedReceiptQuery();
    const [triggerV2] = useLazyGetTedReceiptV2Query();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [tedReceipt, setTedReceipt] = useState();
    async function getTedReceipt(id) {
        setLoading(true);
        setError(false);
        setTedReceipt(undefined);
        try {
            const trigger = isBaasV2Enabled ? triggerV2 : triggerV1;
            const { data } = await trigger({ id }, false);
            if (!data?.result) {
                setError(true);
            }
            else {
                setTedReceipt(data.result);
            }
        }
        catch {
            setError(true);
        }
        finally {
            setLoading(false);
        }
    }
    return {
        loading,
        setLoading,
        error,
        setError,
        tedReceipt,
        setTedReceipt,
        getTedReceipt,
    };
}
